import { render, staticRenderFns } from "./PartnerInviteDialog.vue?vue&type=template&id=22e8e5e4&scoped=true"
import script from "./PartnerInviteDialog.vue?vue&type=script&lang=js"
export * from "./PartnerInviteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8e5e4",
  null
  
)

export default component.exports